'use client'

import JsBarcode from 'jsbarcode'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useEffect } from 'react'

import styles from './Barcode.module.scss'

interface BarcodeProps {
	readonly orderId?: string
	readonly barcode?: string
}
export function Barcode({ orderId, barcode }: BarcodeProps) {
	const { t } = useLabels()

	const description =
		barcode && orderId
			? t('myPurchases.online.details.returns.store.bodycopy')
			: t('myPurchases.online.details.returns.inStore.noCode.bodycopy')

	useEffect(() => {
		if (orderId && barcode) {
			const options = {
				barcode,
				orderId,
				displayValue: false,
				lineColor: '#121314',
				height: 100,
				width: 3,
			}
			JsBarcode(`#${orderId}`, barcode, options)
		}
	}, [orderId, barcode])

	return (
		<div className={styles.container}>
			<p className={styles.description}>{description}</p>
			{orderId && barcode && (
				<div
					className={styles.wrapper}
					data-testid='myPurchases.online.details.returns.store.barcode'
				>
					<svg
						data-testid='myPurchases.online.details.returns.store.barcode.image'
						id={orderId}
						className={styles.barcode}
					/>
					<p className={styles.barcodeText}>{barcode}</p>
				</div>
			)}
		</div>
	)
}
